import React, { PropTypes } from "react";
import axios from "axios";
import Modal from "react-bootstrap/lib/Modal";
import LoadingSpinner from "../../feature/loadingSpinner"
import Constants from "../../classes/constants";

class ReferralJobAccordion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false, referralJob: [], showDialog: false, src:null, jobTitle: null, noOfReferralJob: <LoadingSpinner/>
    };
    this.togglePanel = this.togglePanel.bind(this);
    this.getReferralJobDetails = this.getReferralJobDetails.bind(
      this
    );
  }

   navigate(url){
     var iframe = "<iframe width='100%' height='100%' src='" + url + "'></iframe>"
     var x = window.open();
     x.document.open();
     x.document.write(iframe);
     x.document.close();
   }


  getReferralJobDetails(id) {
    let request = {
      department: this.props.departmentId,
    };

    axios
      .get(
        process.env.REQ_URL +
          "/referral/getReferralJobs?q=" +
          JSON.stringify(request),
        {
          withCredentials: true,
          headers: { "X-Requested-With": "XMLHttpRequest" }
        }
      )
      .then(response => {
        this.setState({ referralJob: response.data.data, requested: true });
        if(response.data.data.length === 0) {
            this.setState({noOfReferralJob: "No jobs under this department"});
        }
      })
      .catch(error => {
        console.log("error while calling api /referral/getReferralJobs");
      });
  }

  togglePanel() {
    if (!this.state.requested && !this.state.open) {
      this.getReferralJobDetails(this.props.departmentId);
    }
    this.setState(({ open }) => ({
      open: !open
    }));
  }

  render() {
    return (
        <div>
          <div className="accordion">
            <div
              className={`accordion_heading${
                this.state.open ? " accord_active" : ""
              }`}
              onClick={this.togglePanel}
            >
              {this.props.header}
              <i className="arrow" />
            </div>
            <div className="accordion_panel">
              <table className="table" cellPadding="5px" cellSpacing="0" border="0">
                <tbody>
                {this.state.referralJob.length === 0 ? this.state.noOfReferralJob :
                     <div>{this.state.referralJob.map((node, index) => {
                      const t = new Date( node.jobPostTime );
                      const formatted = t.toDateString();
                      var referralFileId = "referralFile"+node.id;
                      var viewFileId = "view"+node.id;
                      let url = Constants.tejaUrl+node.jobLink;
                      return (
                          <div style={{marginBottom:"2px"}}>
                            <tr>
                              <td style={{ width: "50%" }}>
                                 <a onClick= { () => {
                                   this.setState({src: url, jobTitle: node.jobTitle, showDialog: true});
                                  }}> {node.jobTitle}</a>
                              </td>
                              <td style={{ textAlign: "center", width: "200px"}}>
                                  {formatted}
                              </td>
                              <td style={{ textAlign: "center", width: "200px", display :"flex"}}>
                               <div>
                                <div className="uploadButton">
                                  <button className="btn btn-primary upload_cta">Upload</button>
                                  <input type="file" onChange={(event)=> {
                                    var reader = new FileReader();
                                    reader.onload = (e) => {
                                      this.setState({src: e.target.result});
                                    };
                                    reader.readAsDataURL(event.target.files[0]);
                                    this.setState({file: event.target.files[0]});
                                    document.getElementById(viewFileId).style.display = 'block';
                                  }} name="referralFile" id = {referralFileId} className="fileUpload" accept=".pdf"  />
                                  <div id="file-upload-filename"></div>
                                </div>
                                <a onClick={()=>{this.navigate(this.state.src)}} style={{display: "none"}} id={viewFileId}> view </a></div>
                                <button className="btn btn-default"  type="button" onClick={(e)=> {
                                              e.preventDefault();

                                              if(!node.id ||!this.state.file) {
                                                  alert("Please fill all the fields.");
                                              } else {
                                                  let data = new FormData();
                                                  data.append('file', this.state.file, "FileName.pdf");
                                                  data.append('jobDetailsId', node.id);
                                                  let xhr = new XMLHttpRequest();
                                                  xhr.open('POST', process.env.REQ_URL + '/referral/addReferral', true);
                                                  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                                                  xhr.withCredentials = true;

                                                  // Set up a handler for when the request finishes.
                                                  xhr.onload = function () {
                                                      if (xhr.status === 200) {
                                                          let jsonData = JSON.parse(xhr.response);
                                                          alert(jsonData.data);
                                                          this.setState({ file:null, src : ""});
                                                          $('#'+referralFileId).val('');
                                                          $("#"+viewFileId).css("display", "none");
                                                      } else {
                                                          alert('An error occurred!');
                                                      }
                                                  }.bind(this);
                                                  xhr.send(data);
                                              }}}
                                          >Save</button>
                               </td>
                            </tr>
                          </div>
                      );


                     })} </div>  }
                </tbody>
              </table>
            </div>
          </div>

            <Modal
                bsSize="large"
                show={this.state.showDialog}
                onHide={() => {
                    this.setState({ showDialog: false });
                }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{this.state.jobTitle}&nbsp;</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <iframe
                        src={this.state.src}
                        width="850"
                        height="500"
                    />
                    <a onClick={()=>{this.navigate(this.state.src)}} download={true}> Download </a>
                </Modal.Body>
            </Modal>

        </div>
    );
  }
}

ReferralJobAccordion.proptypes = {};

export default ReferralJobAccordion;



/** WEBPACK FOOTER **
 ** ./src/components/common/ReferralJobAccordion.js
 **/